export default __webpack_public_path__ + "static/employear-logo-faaf38d95285cce3c2569979dd79d34f.png";